import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {Config} from "../../config/config";

@Injectable()
export class ServiceKeyInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.includes(Config.wordpressEndpoint)) {
      request = request.clone({
        body: Object.assign({}, request.body, {
          'service_key': Config.serviceKey
        })
      });
    }

    return next.handle(request);
  }
}
